import { getHeaders } from "./api";
import { normalizeDocument } from "../components/CompanyOrgStructure/orgStructureMutations";
import { CompanyOrgStructureDocument } from "../components/CompanyOrgStructure/orgStructureTypes";

const BACKEND_URI = ((import.meta as any)?.env?.VITE_BACKEND_URI ?? "").replace(/\/$/, "");

export async function getCompanyOrgStructureApi(
    idToken: string | undefined
): Promise<CompanyOrgStructureDocument> {
    const headers = await getHeaders(idToken);
    const response = await fetch(`${BACKEND_URI}/my-company/org-structure`, {
        method: "GET",
        headers: { ...headers },
        credentials: "same-origin"
    });
    if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
    }
    const data = await response.json();
    return normalizeDocument(data.org_structure);
}

export async function updateCompanyOrgStructureApi(
    payload: CompanyOrgStructureDocument,
    idToken: string | undefined
): Promise<CompanyOrgStructureDocument> {
    const headers = await getHeaders(idToken);
    const response = await fetch(`${BACKEND_URI}/my-company/org-structure`, {
        method: "PUT",
        headers: { ...headers, "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        credentials: "same-origin"
    });
    if (!response.ok) {
        let message = `Request failed with status ${response.status}`;
        try {
            const data = await response.json();
            if (data?.error) message = data.error;
        } catch {
            /* fall through */
        }
        throw new Error(message);
    }
    const data = await response.json();
    return normalizeDocument(data.org_structure);
}
